module.exports = __webpack_public_path__ + "media/images/japan/highlight-c31986e217e3f85fe292ac179e217d10.svg";